import { Editor } from '../core/Editor';
import { Icons } from './Icons';

export class CloudflareModal {
  private editor: Editor;
  private container: HTMLDivElement | null = null;

  constructor(editor: Editor) {
    this.editor = editor;
  }

  public open() {
    this.close();

    const overlay = document.createElement('div');
    overlay.className = 'modal-backdrop';
    overlay.id = 'cloudflare-modal';

    overlay.innerHTML = `
      <div class="modal-card cloudflare-card">
        <div class="modal-header">
          <div class="modal-title-group">
            <div class="modal-icon cf-icon">${Icons.cloudflare}</div>
            <div>
              <h3>Cloudflare Deployment</h3>
              <p class="modal-subtitle">Publish Iron Crop to <strong>photo.drb.wang</strong></p>
            </div>
          </div>
          <button class="modal-close-btn" id="close-cf-modal">&times;</button>
        </div>

        <div class="modal-body cf-modal-body">
          <div class="cf-domain-badge">
            <span class="pulse-dot"></span>
            <span>Target Host: <strong>photo.drb.wang</strong></span>
            <span class="cf-status-tag">Cloudflare Pages Ready</span>
          </div>

          <div class="cf-step-box">
            <div class="cf-step-num">1</div>
            <div class="cf-step-content">
              <h4>Build Production Bundle</h4>
              <p>Compiles optimized TypeScript, HTML, CSS, and static assets into <code>dist/</code>:</p>
              <div class="code-copy-box">
                <code>npm run build</code>
                <button class="copy-code-btn" data-code="npm run build">${Icons.copy}</button>
              </div>
            </div>
          </div>

          <div class="cf-step-box">
            <div class="cf-step-num">2</div>
            <div class="cf-step-content">
              <h4>Deploy with Wrangler to Cloudflare</h4>
              <p>Upload the production build directly to your Cloudflare Pages project:</p>
              <div class="code-copy-box">
                <code>npx wrangler pages deploy dist --project-name photo-drb-wang</code>
                <button class="copy-code-btn" data-code="npx wrangler pages deploy dist --project-name photo-drb-wang">${Icons.copy}</button>
              </div>
            </div>
          </div>

          <div class="cf-step-box">
            <div class="cf-step-num">3</div>
            <div class="cf-step-content">
              <h4>Assign Custom Domain in Cloudflare Dashboard</h4>
              <p>In Cloudflare Dashboard &rarr; <strong>Workers & Pages</strong> &rarr; <strong>photo-drb-wang</strong> &rarr; <strong>Custom domains</strong>:</p>
              <ul>
                <li>Click <strong>Set up a domain</strong></li>
                <li>Enter <code>photo.drb.wang</code></li>
                <li>Cloudflare will automatically manage SSL certificates and edge routing</li>
              </ul>
            </div>
          </div>

          <div class="cf-config-summary">
            <div class="summary-item">
              <span class="lbl">Configuration File:</span>
              <span class="val"><code>wrangler.toml</code> (configured)</span>
            </div>
            <div class="summary-item">
              <span class="lbl">Output Directory:</span>
              <span class="val"><code>dist/</code></span>
            </div>
            <div class="summary-item">
              <span class="lbl">Edge CDN Caching:</span>
              <span class="val">Enabled (Global Cloudflare Anycast)</span>
            </div>
          </div>
        </div>

        <div class="modal-actions">
          <button class="btn btn-secondary" id="cf-done-btn">Close</button>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
    this.container = overlay;

    overlay.querySelector('#close-cf-modal')?.addEventListener('click', () => this.close());
    overlay.querySelector('#cf-done-btn')?.addEventListener('click', () => this.close());

    // Copy buttons
    overlay.querySelectorAll('.copy-code-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const target = e.currentTarget as HTMLElement;
        const code = target.dataset.code || '';
        navigator.clipboard.writeText(code).then(() => {
          this.editor.showToast('Copied command to clipboard!');
        });
      });
    });
  }

  public close() {
    if (this.container) {
      this.container.remove();
      this.container = null;
    }
  }
}
